import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Statistic from './utils/statistic'
// import VueLazyLoad from 'vue-lazyload' // 项目中引入vue-lazyload插件
// import infiniteScroll from 'vue-infinite-scroll'

// axios
import { post, get } from './utils/request'
import { requestUrl as url } from './api/requestUrl'

// 引入UI库样式资源
import 'element-ui/lib/theme-chalk/index.css'

// 默认样式
import '@/styles/index.css'

// 适配依赖
// import 'lib-flexible'
// import { setRemInit } from '../src/rem';

// setRemInit()

// import $ from 'jquery'
// 引入echarts
import echarts from 'echarts'

// Vue.use(infiniteScroll)
// Vue.use(VueLazyLoad, {
//   error: 'data-src', // 加载图片出错了，显示的图片
//   loading: 'data-src', // 加载中，显示的图片（预加载显示的图片）
//   attempt: 3, // 尝试加载的图片数量
//   preLoad: 1.3, // 预加载的高度比例
//   listenEvents: ['scroll'] // 触发的事件 (监听)
// })

Vue.use(Statistic)

Vue.prototype.$echarts = echarts

// 注册使用UI库组件
Vue.use(ElementUI)

// vue原型链方法
// Vue.prototype.$http = axios // 服务器请求基地址
Vue.prototype.$post = post // post请求
Vue.prototype.$get = get // get请求
Vue.prototype.$url = url // 接口请求地址

Vue.config.productionTip = false
Vue.config.productionTip = false

Vue.prototype.$bus = new Vue()
Vue.prototype.$eventBus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
